import { render, staticRenderFns } from "./BimProgressDashBoard.vue?vue&type=template&id=39492bc9&scoped=true"
import script from "./BimProgressDashBoard.vue?vue&type=script&lang=js"
export * from "./BimProgressDashBoard.vue?vue&type=script&lang=js"
import style0 from "./BimProgressDashBoard.vue?vue&type=style&index=0&id=39492bc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39492bc9",
  null
  
)

export default component.exports